import { px2rem } from 'decisiv-ui-utils';
import PropTypes from 'prop-types';
import React from 'react';
import { compact } from 'lodash';

import ScrollableContainer from 'elements/ScrollableContainer';

import ServiceProvider from './ServiceProvider';

function ServiceProvidersList({
  onSelect,
  selectedServiceProvider,
  serviceProviders,
}) {
  return (
    <ScrollableContainer modifiers={['fluid']} style={{ height: px2rem(330) }}>
      <ScrollableContainer.List>
        {serviceProviders.map((serviceProvider) => {
          const isSelected = serviceProvider.id === selectedServiceProvider.id;
          return (
            <ScrollableContainer.ListElement
              key={serviceProvider.id}
              modifiers={compact([isSelected && 'selected'])}
            >
              <ServiceProvider
                serviceProvider={serviceProvider}
                onSelect={onSelect}
                isSelected={isSelected}
              />
            </ScrollableContainer.ListElement>);
        })}
      </ScrollableContainer.List>
    </ScrollableContainer>
  );
}

ServiceProvidersList.propTypes = {
  onSelect: PropTypes.func.isRequired,
  selectedServiceProvider: PropTypes.shape({
    id: PropTypes.string,
  }),
  serviceProviders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ).isRequired,
};

ServiceProvidersList.defaultProps = {
  selectedServiceProvider: {},
};

export default ServiceProvidersList;



// WEBPACK FOOTER //
// ./components/ServiceProvidersList/index.js